import React, { useState, Fragment, useEffect } from 'react'
import { useForm } from 'react-hook-form';
import { Link, } from 'react-router-dom';
import { Form, FormGroup, Row, Col, Table, CardBody, Card } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import "../../../assets/css/requireDoc.css";
import { Submit, Back, AddMoreDocuments, DOCUMENTS_DETAILS, PROJECTS_DATA } from '../../../Common/Constant';
import { useDispatch, useSelector, useStore } from 'react-redux';
import fetchWrapper from '../../../Common/api/fetchWrapper';
import { toast } from 'react-toastify';
import { Download } from 'react-feather';
import { API_URL } from '../../Config/Config';
import Dropzone from 'react-dropzone-uploader';


const RequiredDocuments = ({ setSteps, setFormdata, formdata }) => {
    console.log(formdata);
    const { register, handleSubmit, formState: { errors }, resetField, trigger, clearErrors } = useForm();
    const [fileArray, setFileArray] = useState(formdata.documents || []);
    const [sizeExceed, setSizeExceed] = useState(false);
    const [documentType, setDocumentType] = useState()
    const [otherValue, setOtherValue] = useState()
    const [registry, setRegistry] = useState(formdata?.registry)
    const dispatch = useDispatch();
    const [documentList, setDocumentList] = useState([]);
    const [loading, setLoading] = useState(false)

    const getUploadParams = ({ meta }) => { return { url: 'https://httpbin.org/post' } }

    const handleDocument = (val) => {
        setDocumentType(val)    
        clearErrors('documentType')
    }

    const handleOtherDocument = (val) => {
        setOtherValue(val)
        clearErrors();
    }

    const handleUpload = async (files) => {
        if (errors?.documentType || errors?.otherDocumentType) {
            toast.error('Please select document type')
            return
        } else {
            if (fileArray && fileArray.length < 5) {
                setLoading(true)
                const projectId = sessionStorage.getItem('projectId')
                const authToken = sessionStorage.getItem('accessToken')
                const file = files[0]?.file
                // let tempFile = new File([file], `${formdata?.projectName + '_' + file.name}`, {
                //     type: file.type
                // })
                let data = new FormData();
                data.append('file', file)
                data.append('documentTypeName', documentType)
                data.append('otherDocumentTypeName', otherValue)
                const options = {
                    method: 'POST',
                    headers: {
                        "Authorization": `Bearer ${authToken}`
                    },
                    body: data
                }
                await fetchWrapper(`${API_URL}/document?projectId=${projectId}`, options)
                    .then((res) => {
                        console.log(res)
                        if (res.ok) {
                            let arr = [...fileArray];
                            arr.push(res.json);
                            setFileArray(arr);
                            setSizeExceed(false)
                            setFormdata(pre => ({ ...pre, ...arr }))
                            resetField('documentType')
                            resetField('otherDocumentType')
                            setLoading(false)
                            toast.success('Document Uploaded successfully!')
                        }
                    })
                    .catch((error) => {
                        setLoading(false)
                        console.error(error)
                        if (error.status == 412) {
                            toast.error('File with the same name already exists')
                        }
                    })

            }
        }
    };

    const loadData = async () => {
        const options = {
            method: 'GET'
        }
        await fetchWrapper(`${API_URL}/document/type/${registry}`, options)
            .then(res => {
                console.log(res)
                setDocumentList(res.json);
            })
    }

    useEffect(() => {
        loadData()
    }, [])


    const handleBack = () => {
        // setValue('documents', fileArray);
        formdata.documents = [...fileArray];
        setSteps(pre => pre - 1)
    }

    const handleNext = async () => {
        setSteps(pre => pre + 1)
    }

    const downloadDocs = async (id, name) => {
        await fetchWrapper(`${API_URL}/document/downloadDocument/${id}`)
            .then(async (res) => {
                console.log(res.json)
                if (res.status === 200) {
                    const link = document.createElement('a');
                    link.href = res?.json?.presignedUrl;
                    link.download = name;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
                if (res.status === 500) {
                    toast.error('Something went wrong!')
                }
            })
            .catch(err => {
                console.log(err)
                if (err?.status === 404) {
                    toast.error('File not found..')
                }
            })
    }
    
    return (
        <Fragment>
            <h2 className="pb-3 text-color">Required Documents</h2>
            <Row>
                <Col sm="6">
                    <FormGroup className="mb-3">
                        <label>Document Type</label>
                        <select className='form-select'
                            {...register('documentType', { required: true })}
                            onChange={(e) => handleDocument(e.target.value)}
                        >
                            <option value=''>Select Document Type</option>
                            {
                                documentList && documentList.length > 0 && documentList?.map((item) => {
                                    return <option value={item.documentTypeName}>{item.documentTypeName}</option>
                                })
                            }
                        </select>
                        <span className="text-danger">{errors.documentType && errors.documentType.type === 'required'
                            && 'Select Document Type'}</span>
                    </FormGroup>
                </Col>
                <Col sm='6'>
                    {
                        documentType === 'Others' && <FormGroup>
                            <label>Other Document Type <span className="text-danger">*</span></label>
                            <input className={`form-control mb-1`} placeholder='' type="text"
                                name='otherDocumentType'
                                {...register('otherDocumentType', { required: true })}
                                onChange={(e) => handleOtherDocument(e.target.value)} />
                            <span className="text-danger">{errors.otherDocumentType && errors.otherDocumentType.type === 'required'
                                && 'Other Document Type Required'}</span>
                        </FormGroup>
                    }
                </Col>
            </Row>
            <Row>
                <Col sm='6'>
                    <FormGroup className="mb-3">
                        <div className="dz-message needsclick">
                            <Dropzone
                                maxFiles={1}
                                multiple={false}
                                accept='.xlsx,.xls, .pdf, .doc, .txt, .jpeg, .kml'
                                getUploadParams={getUploadParams}
                                onChangeStatus={async () => {
                                    const result = await trigger();
                                }}
                                onSubmit={handleUpload}
                                maxSizeBytes={4194304}
                                inputContent="Drag and Drop Files"
                            />
                        </div>
                        <div>
                            {
                                fileArray && fileArray.length === 5 && <span className='text-danger'>Only 5 docs are allowed</span>
                            }
                            {
                                sizeExceed && <span className='text-danger'>File size should be below 5 MB</span>
                            }
                        </div>
                        <p>[Note:Supported formats xlsx,xls,PDF,Doc]</p>

                        {/* {errors.reqdocs && <span>{errors.reqdocs.message}</span>} */}
                    </FormGroup>
                </Col>
            </Row>
            <div>
                <Btn attrBtn={{ color: 'primary', type: 'submit', className: 'btn-font', onClick: handleNext }}>{"Next"}</Btn>
                <Btn attrBtn={{ color: 'light', outlined: true, onClick: handleBack, className: 'btn-font ml-1', }}>{Back}</Btn>
            </div>
            <Card className='notes-card'>
                <CardBody>
                    <Row>
                        <Col lg='12'>
                            <Table striped bordered>
                                <thead className='f-16'>
                                    <tr className='table-header-bg'>
                                        <th>Document Name</th>
                                        <th>Type</th>
                                        <th>Size</th>
                                        <th>Download</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        fileArray && fileArray.length > 0 && fileArray.map((item) => {
                                            return (
                                                <tr className='table-body'>
                                                    <td>{item.originalFileName}</td>
                                                    <td>{item.documentTypeName === 'Others' ? item.otherDocumentTypeName : item.documentTypeName}</td>
                                                    <td>{(item.size / 1024).toFixed()}KB</td>
                                                    <td>
                                                    <div onClick={() => downloadDocs(item.id, item.originalFileName)}>
                                                            <Download className='document-icon' />
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                            {
                                fileArray && fileArray?.length == 0 && <div className='d-flex-center mtop-2'>No Data Found..</div>
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>


        </Fragment>
    )
}

export default RequiredDocuments